import React from "react"

import { useStore } from "@/store"

const CalendarViewContainer = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  const store = useStore()
  const dimensions = store.calendarDimensions

  return (
    <div
      ref={ref}
      style={{ height: dimensions?.viewport?.height || 0 }}
      data-testid="panel-reservations-calendar-container"
      {...props}
    />
  )
})

CalendarViewContainer.displayName = "CalendarViewContainer"

export default CalendarViewContainer
